export default "__VITE_ASSET__vxOumyIV__"